import IMs from "./config/IMs.js";
import EVENTS from "./config/EVENTS.js";

export default {
    HOST: process.env?.VUE_APP_HOST || 'https://1task.ru',
    LIVE_HOST: "",	// empty for same host as FE todo why is it used?
    API_HOST: "",	// empty for same host as FE todo why is it used?
    API_DEFAULT_ACTION: '/api/Form',

    API_WITH_WS: true,
    API_SERVER_WS_URI: process.env?.VUE_APP_WS_SERVER || 'wss://1task.ru/ws',
    API_SERVER_WS_PORT: '', // keep empty if nginx proxies to a server port
    API_SERVER_WS_EDITOR_URI: process.env?.VUE_APP_WS_EDITOR || 'wss://1task.ru/editor',

    VAPID_PUBLIC_KEY: process.env?.VUE_APP_VAPID_PUBLIC_KEY || '',
    YA_COUNTER_NAME: '',	// fixme

    DEFAULT_TITLE: "1Task",

    PUBLIC_TAG_NAMES: ["ai-instruction"],

    STORAGE_CLIENT_ID_TOKEN: "auth",
    STORAGE_CLIENT_IM_KEY: "authIMKey",
    STORAGE_APP_ID: "appId",
    STORAGE_CONFIG: "config",
    STORAGE_CURRENT_GROUP_AUTH: "group",
    STORAGE_GROUP_IDS: "groupIds",
    STORAGE_GROUP_TAB: "tab",
    STORAGE_GROUP_SEARCH: "search",
    STORAGE_WORKSPACE_AUTH: "workspace",
    STORAGE_TAB_ID_TOKEN: "tab",
    STORAGE_USER_LIST_MODE: "user-list-mode",
    STORAGE_SHOW_HIDDEN_TASKS: "show-hidden-tasks",
    STORAGE_USER_CONTEXT_TREE: "user-context-tree",
    STORAGE_TEXT_TASK_LIST: "text-task-list",
    /** Закрытые узлы (проекты и папки) дерева пользовательского контекста */
    STORAGE_USER_TREE_CLOSED: "user-tree-closed",
    STORAGE_AI_CHAT_DEBUG_MODE: "ai-chat-debug-mode",
    STORAGE_OPEN_CONTEXTS: "open-folders",

    /** Сколько часов после создания задача считается новой (тег "new" в списке задач) */
    NEW_TASK_HOURS: 2,
    STORAGE_OPEN_QUICK_TAGS: "open-quick-tags",
    STORAGE_OPEN_TASKS: "open-tasks",
    STORAGE_CLOSED_SECTIONS: "closed-sections",
    STORAGE_SEARCH_DISABLED_TABS: "search-disabled-tabs",
    STORAGE_SEARCH_GROUP_IDS: "search-group-ids",
    STORAGE_TASK_PREFERRED_USER_IDS: "preferred-task-users",
    STORAGE_CONTEXT_TASKS_FILTER: "context-tasks-filter",
    STORAGE_AUTH_EMAIL: "authEmail",
    STORAGE_INVITATION_ID: "invitationId",
    STORAGE_TOUR_STATE: "tour",

    SESSION_LAST_CONTEXT_ID: "last-context-id",

    WS_CONNECT_CHECK_EVERY_MS: 300,
    WS_CONNECT_TIMEOUT_MS: 12000,
    WS_RESPONSE_CHECK_EVERY_MS: 30,
    WS_RESPONSE_TIMEOUT_MS: 30000,

    WS_ACTION_HELLO: "user/hello",

    API_EXCEPTION_EXISTS: 'EXISTS',
    API_EXCEPTION_CODE_404: 404,
    API_EXCEPTION_CODE_403: 403,

    REFRESH_PAGE_ON_INACTIVITY_AFTER_SECONDS: 15 * 60,

    DEBOUNCE_INPUT_TIMEOUT: 800,
    DEBOUNCE_INPUT_TIMEOUT_SHORT: 400,
    DEBOUNCE_INPUT_TIMEOUT_LONG: 1500,

    COLORS: [
        {
            isActive: true,
            color: "#7E57C2",
            bg: "#EDE7F6",
            fg: "#fff",
            dark: true,
            css: "--color4",
            map: "deep-purple lighten-5",
            icon: "deep-purple lighten-1",
            name: "Фиолетовый"
        },
        {
            isActive: true,
            color: "#29B6F6",
            bg: "#E1F5FE",
            fg: "#fff",
            dark: true,
            css: "--color7",
            map: "light-blue lighten-5",
            icon: "light-blue lighten-1",
            name: "Голубой"
        },
        {
            isActive: true,
            color: "#66BB6A",
            bg: "#E8F5E9",
            fg: "#fff",
            dark: true,
            css: "--color10",
            map: "green lighten-5",
            icon: "green lighten-1",
            name: "Зеленый"
        },
        {
            isActive: true,
            color: "#FFEE58",
            bg: "#FFFDE7",
            fg: "#888",
            dark: false,
            css: "--color13",
            map: "yellow lighten-5",
            icon: "yellow lighten-1",
            name: "Желтый"
        },
        {
            isActive: true,
            color: "#FFA726",
            bg: "#FFF3E0",
            fg: "#fff",
            dark: true,
            css: "--color15",
            map: "orange lighten-5",
            icon: "orange lighten-1",
            name: "Оранжевый"
        },
        {
            isActive: true,
            color: "#EF5350",
            bg: "#FFEBEE",
            fg: "#fff",
            dark: true,
            css: "--color1",
            map: "red lighten-5",
            icon: "red lighten-1",
            name: "Красный"
        },
        {
            color: "#EC407A",
            bg: "#FCE4EC",
            fg: "#fff",
            dark: true,
            css: "--color2",
            map: "pink lighten-5",
            icon: "pink lighten-1",
            name: "Розовый"
        },
        {
            color: "#AB47BC",
            bg: "#F3E5F5",
            fg: "#fff",
            dark: true,
            css: "--color3",
            map: "purple lighten-5",
            icon: "purple lighten-1",
            name: "Пурпурный"
        },
        {
            color: "#7E57C2",
            bg: "#E8EAF6",
            fg: "#fff",
            dark: true,
            css: "--color5",
            map: "indigo lighten-5",
            icon: "indigo lighten-1",
            name: "Индиго"
        },
        {
            color: "#42A5F5",
            bg: "#E3F2FD",
            fg: "#fff",
            dark: true,
            css: "--color6",
            map: "blue lighten-5",
            icon: "blue lighten-1",
            name: "Синий"
        },
        {
            color: "#26C6DA",
            bg: "#E0F7FA",
            fg: "#fff",
            dark: true,
            css: "--color8",
            map: "cyan lighten-5",
            icon: "cyan lighten-1",
            name: "Бирюзовый"
        },
        {
            color: "#26A69A",
            bg: "#E0F2F1",
            fg: "#fff",
            dark: true,
            css: "--color9",
            map: "teal lighten-5",
            icon: "teal lighten-1",
            name: "Зеленовато-синий"
        },
        {
            color: "#9CCC65",
            bg: "#F1F8E9",
            fg: "#888",
            dark: false,
            css: "--color11",
            map: "light-green lighten-5",
            icon: "light-green lighten-1",
            name: "Светло-зеленый"
        },
        {
            color: "#D4E157",
            bg: "#F9FBE7",
            fg: "#888",
            dark: false,
            css: "--color12",
            map: "lime lighten-5",
            icon: "lime lighten-1",
            name: "Зеленый лаймовый"
        },
        {
            color: "#FFCA28",
            bg: "#FFF8E1",
            fg: "#888",
            dark: false,
            css: "--color14",
            map: "amber lighten-5",
            icon: "amber lighten-1",
            name: "Янтарный"
        },
        {
            color: "#FF7043",
            bg: "#FBE9E7",
            fg: "#fff",
            dark: true,
            css: "--color16",
            map: "deep-orange lighten-5",
            icon: "deep-orange lighten-1",
            name: "Темно-оранжевый"
        },
        {
            color: "#8D6E63",
            bg: "#EFEBE9",
            fg: "#fff",
            dark: true,
            css: "--color17",
            map: "brown lighten-5",
            icon: "brown lighten-1",
            name: "Коричневый"
        },
        {
            color: "#78909C",
            bg: "#ECEFF1",
            fg: "#fff",
            dark: true,
            css: "--color18",
            map: "blue-grey lighten-5",
            icon: "blue-grey lighten-1",
            name: "Сине-серый"
        },
        {
            color: "#BDBDBD",
            bg: "#FAFAFA",
            fg: "#fff",
            dark: true,
            css: "--color19",
            map: "grey lighten-5",
            icon: "grey lighten-1",
            name: "Серый"
        },
        {
            color: "#000000",
            bg: "#888",
            fg: "#fff",
            dark: true,
            css: "--color20",
            map: "black",
            icon: "black",
            name: "Черный"
        },
        {isActive: true, color: "#fff", bg: null, fg: "#888", dark: false, css: null, map: null, name: "Без цвета"},
    ],
    GROUP_AUTO_ARCHIVED_AFTER_DAYS: 30,

    //in _variables.scss, config.js and plugins/vuetify.js
    WIDTH_SM: 420,
    WIDTH_MD: 1280,
    WIDTH_LG: 1440,
    WIDTH_XL: 1920,

    TODOS_MAX_MAIN: 7,
    TODOS_MAX_PRIO: 3,
    CONTEXT_MAX_TASKS: 100,
    TASKS_MAX_LEVEL: 4, // 2 times of max at server
    MAX_STAGES: 10,

    // виртуализация (windowed rendering) корневого списка задач - см. context-tasks.vue
    CONTEXT_VIRTUALIZE_THRESHOLD: 80, // Infinity полностью отключает виртуализацию
    CONTEXT_VIRTUALIZE_ROW_HEIGHT: 64, // оценка высоты строки до её реального измерения
    CONTEXT_VIRTUALIZE_INITIAL_ROWS: 40, // сколько строк рендерить, пока контейнер ещё не измерен

    DAY_LABELS: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вск"],

    AUTH_LENGTH: 16,
    CLIENT_ID_LENGTH: 16,
    CLIENT_ID_ALPHABET: "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-",
    // должны совпадать с backend/src/config.ts TASK_ID_LENGTH/TASK_ID_ALPHABET - используются,
    // чтобы FE мог сгенерировать реальный id задачи заранее (см. store/task/mutations.js#taskCreate)
    TASK_ID_LENGTH: 24,
    TASK_ID_ALPHABET: "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-",
    ANONYMOUS_USER_ID: "-___ANONYMOUS___",

    QUERY_UI_OPTION_KEY: "ui",
    QUERY_UI_OPTIONS: {
        DELAY: "delay",
        DEADLINE: "deadline",
        START: "start",
        FOCUS: "focus",
    },
    QUERY_UI_REFRESHES: {
        EDITOR: "re",
    },
    QUERY_RANDOM_KEY: "r",

    /** Индексы вкладок диалога группы (ui/dialogGroup, tabIndex) в порядке следования в dialog-group.vue */
    DIALOG_GROUP_TABS: {MAIN: 0, MEMBERS: 1, QUICK_TAGS: 2, IMS: 3, NOTIFICATIONS: 4, SORTING: 5, TARIFF: 6},
    /** Индексы вкладок диалога пользователя (ui/dialogUser, tabIndex) в порядке следования в dialog-user.vue */
    DIALOG_USER_TABS: {NOTIFICATIONS: 0, IMS: 1, PERSONALIZATION: 2, AI_ASSISTANT: 3},

    CONTEXT_ID_CHAIN_SEP: ".",
    CONTEXT_INDEX_STEP: 100,

    ROUTING_FADE_IN_TIME: 200,

    ZINDEX_OVER_DIALOGS: 300,

    // TODO move to backend
    NOTIFICATION_MODE: {
        RECOMMENDED: 0,
        MANUAL: 1,
        OFF: 2,
    },
    NOTIFICATION_ROLES: [
        {name: "user", label: "Ответственный"},
        {name: "owner", label: "Контроллер"},
        {name: "companion", label: "Соисполнитель"},
        /*{name: "creator", label: "Создатель"},*/
    ],
    NOTIFICATION_EVENTS: [
        {name: "Task", label: "Создана новая задача"},
        {name: "Rename", label: "Задача/папка переименована"},
        {name: "Assign", label: "Назначение ответственного "},
        {name: "Comment", label: "Комментарий к задаче"},
        {name: "Done", label: "Задача выполнена"},
        {name: "Report", label: "Задача сдана на проверку контроллеру"},
        {name: "Undone", label: "Задача не выполнена"},
        {name: "Repeat", label: "Задача повторилась"},
        {name: "StageDone", label: "Шаг выполнен"},
        {name: "StageUndone", label: "Шаг не выполнен"},
        {name: "Prio", label: "Задача поставлена в приоритет"},
        {name: "Unprio", label: "У задачи снят приоритет"},
        {name: "Delay", label: "Задача отложена"},
        {name: "Undelay", label: "Задача вернулась из отложенных"},
        {name: "Deadline", label: "Установлен дедлайн"},
        {name: "TaskDue", label: "Сегодня дедлайн по задаче"},
        {name: "TaskOverdue", label: "Задача просрочена"},
        {name: "Delete", label: "Задача удалена"},
        //{name: "AccessRequest", label: "Запрос доступа"},
    ],
    // TODO move to BE
    RECOMMENDED_GROUP_NOTIFICATION_SETTINGS: "{\"mode\":0,\"events\":{\"Task\":true,\"Repeat\":true,\"Comment\":true}}",
    RECOMMENDED_USER_NOTIFICATION_SETTINGS: "{\"mode\":0,\"events\":{\"Task\":[\"user\",\"owner\"],\"Repeat\":[\"user\",\"owner\"],\"Rename\":[\"user\",\"owner\"],\"Assign\":[\"user\",\"owner\"],\"Comment\":[\"user\",\"owner\",\"companion\"],\"Done\":[\"user\",\"owner\"],\"Undone\":[\"user\",\"owner\"],\"Prio\":[\"user\",\"owner\"],\"Unprio\":[\"owner\",\"user\"],\"Delay\":[\"user\",\"owner\"],\"Undelay\":[\"owner\",\"user\"],\"Deadline\":[\"user\",\"owner\"],\"TaskDue\":[\"owner\",\"user\"],\"TaskOverdue\":[\"owner\",\"user\"],\"Delete\":[\"owner\",\"user\"],\"AccessRequest\":[\"user\",\"owner\"],\"StageDone\":[\"user\",\"owner\"],\"StageUndone\":[\"user\",\"owner\"]},\"ims\":[\"push\",\"tg\"]}",
    RECEIVERS: [
        /*{name: "all", label: "Всем участникам", title: "Уведомление будет отправлено всем участникам группы"},*/
        {
            name: "assignee",
            label: "Ответственному",
            title: "Уведомление будет отправлено ответственному по задаче, если он назначен"
        },
        {
            name: "owner",
            label: "Контроллеру",
            title: "Уведомление будет отправлено контролеру задачи, если он назначен"
        },
        {name: "creator", label: "Создателю", title: "Уведомление будет отправлено создателю задачи"},
        {name: "writers", label: "Редакторам", title: "Уведомление будет отправлено всем редакторам задачи"},
        {name: "readers", label: "Читателям", title: "Уведомление будет отправлено всем читателям задачи"},
        {
            name: "group",
            label: "В чат",
            withIMs: true,
            title: "Уведомление будет отправлено в чат группы в мессенджере"
        },

        /*{name: "companions", label: "Соисполнителям"},*/
    ],

    BOT_IDS: [310],

    OAUTH: {
        GOOGLE: {
            API_KEY: process.env?.VUE_APP_OATH_GOOGLE_API_KEY || "AIzaSyCmLKFhM5GiUQ_zNawSqDbvd2ERuH40l4c",
            AUTH_DOMAIN: process.env?.VUE_APP_OATH_GOOGLE_AUTH_DOMAIN || "task-auth-e23ef.firebaseapp.com",
            PROJECT_ID: process.env?.VUE_APP_OATH_GOOGLE_PROJECT_ID || "task-auth-e23ef",
            STORAGE_BUCKET: process.env?.VUE_APP_OATH_GOOGLE_STORAGE_BUCKET || "task-auth-e23ef.firebasestorage.app",
            MESSAGING_SENDER_ID: process.env?.VUE_APP_OATH_GOOGLE_MESSAGING_SENDER_ID || "34165751643",
            APP_ID: process.env?.VUE_APP_OATH_GOOGLE_APP_ID || "1:34165751643:web:94e7c4485f5fa375bba47e",
            EMAIL_LINK_URL: process.env?.VUE_APP_OATH_GOOGLE_EMAIL_LINK_URL || "https://1task.ru/",
        },
        YANDEX: {
            CLIENT_ID: process.env?.VUE_APP_OATH_YANDEX_CLIENT_ID || "813d7f100eab401e8dde1965e5739c5b",
            CLIENT_SECRET: process.env?.VUE_APP_OATH_YANDEX_CLIENT_SECRET || "5d0db4a446d7408e979b874b958f1c64",
            REDIRECT_URI: process.env?.VUE_APP_OAUTH_YANDEX_REDIRECT || "https://1task.ru/_/auth/yandex",
            HOST: process.env?.VUE_APP_OAUTH_YANDEX_HOST || "https://1task.ru",
        }
    },

    ...IMs,
    EVENTS,
}
